import { render } from "./whatsAppView.vue?vue&type=template&id=3ed552e0&scoped=true"
import script from "./whatsAppView.vue?vue&type=script&lang=js"
export * from "./whatsAppView.vue?vue&type=script&lang=js"

import "./whatsAppView.vue?vue&type=style&index=0&id=3ed552e0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ed552e0"]])

export default __exports__